export const MessageIcon = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.3333 2.66666H2.66665C1.93027 2.66666 1.33331 3.26362 1.33331 4V12C1.33331 12.7364 1.93027 13.3333 2.66665 13.3333H13.3333C14.0697 13.3333 14.6666 12.7364 14.6666 12V4C14.6666 3.26362 14.0697 2.66666 13.3333 2.66666Z"
      stroke="currentColor"
      stroke-width="1.33333"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M14.6666 4.66666L8.68665 8.46666C8.48083 8.59561 8.24286 8.664 7.99998 8.664C7.7571 8.664 7.51913 8.59561 7.31331 8.46666L1.33331 4.66666"
      stroke="currentColor"
      stroke-width="1.33333"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const editIcon = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.3333 2C11.5031 1.79936 11.7131 1.63604 11.95 1.52045C12.1869 1.40487 12.4454 1.33956 12.7091 1.32868C12.9728 1.3178 13.2359 1.36159 13.4816 1.45726C13.7273 1.55293 13.9502 1.69838 14.1362 1.88435C14.3221 2.07031 14.4671 2.29271 14.5617 2.53736C14.6563 2.78201 14.6985 3.04356 14.6857 3.30532C14.6729 3.56708 14.6053 3.82332 14.4872 4.05771C14.3692 4.2921 14.2032 4.49949 14 4.66667L4.99998 13.6667L1.33331 14.6667L2.33331 11L11.3333 2Z"
      stroke="CurrentColor"
      stroke-width="1.33333"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M10 3.33334L12.6667 6"
      stroke="CurrentColor"
      stroke-width="1.33333"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const deleteIcon = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2 4H14"
      stroke="CurrentColor"
      stroke-width="1.33333"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12.6666 4V13.3333C12.6666 14 12 14.6667 11.3333 14.6667H4.66665C3.99998 14.6667 3.33331 14 3.33331 13.3333V4"
      stroke="CurrentColor"
      stroke-width="1.33333"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M5.33331 4V2.66667C5.33331 2 5.99998 1.33334 6.66665 1.33334H9.33331C9.99998 1.33334 10.6666 2 10.6666 2.66667V4"
      stroke="CurrentColor"
      stroke-width="1.33333"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M6.66669 7.33334V11.3333"
      stroke="CurrentColor"
      stroke-width="1.33333"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M9.33331 7.33334V11.3333"
      stroke="CurrentColor"
      stroke-width="1.33333"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const cameraIcon = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.66669 4.66666H5.33335L6.33335 3.33332H9.66669L10.6667 4.66666H13.3334C13.687 4.66666 14.0261 4.80713 14.2761 5.05718C14.5262 5.30723 14.6667 5.64637 14.6667 5.99999V12.3333C14.6667 12.6869 14.5262 13.026 14.2761 13.276C14.0261 13.5261 13.687 13.6667 13.3334 13.6667H2.66669C2.31307 13.6667 1.97393 13.5261 1.72388 13.276C1.47383 13.026 1.33335 12.6869 1.33335 12.3333V5.99999C1.33335 5.64637 1.47383 5.30723 1.72388 5.05718C1.97393 4.80713 2.31307 4.66666 2.66669 4.66666Z"
      stroke="CurrentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle
      cx="8"
      cy="9"
      r="2.33333"
      stroke="CurrentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const eyeIcon = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.33331 8C1.33331 8 3.33331 3.33334 7.99998 3.33334C12.6666 3.33334 14.6666 8 14.6666 8C14.6666 8 12.6666 12.6667 7.99998 12.6667C3.33331 12.6667 1.33331 8 1.33331 8Z"
      stroke="CurrentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle
      cx="8"
      cy="8"
      r="2"
      stroke="CurrentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const filtericonsvg=<svg xmlns="http://www.w3.org/2000/svg" width="23" height="24" viewBox="0 0 23 24" fill="none">
  <path d="M20.6503 1H2.34772C2.08885 0.999774 1.83541 1.07575 1.61773 1.21882C1.40006 1.36189 1.22739 1.566 1.12039 1.8067C1.0134 2.04741 0.976624 2.3145 1.01447 2.57599C1.05231 2.83749 1.16316 3.08231 1.33376 3.28113L8.47326 11.6109C8.68799 11.8618 8.80618 12.1838 8.80586 12.517V19.2187C8.80586 19.3255 8.8302 19.4307 8.87694 19.5262C8.92369 19.6217 8.99155 19.7047 9.07517 19.7687L13.1149 22.8625C13.2149 22.9391 13.3339 22.9858 13.4584 22.9972C13.5829 23.0087 13.7081 22.9845 13.8199 22.9274C13.9318 22.8703 14.0258 22.7825 14.0916 22.6739C14.1573 22.5653 14.1921 22.4402 14.1921 22.3125V12.517C14.1918 12.1838 14.31 11.8618 14.5247 11.6109L21.6642 3.27975C22.4264 2.3915 21.807 1 20.6503 1Z" stroke="#1D2951" stroke-width="2" stroke-linecap="round"/>
</svg>